import {Grid, Box, Tooltip, Typography, useTheme} from '@mui/material';
import {node, bool, func, string} from 'prop-types';
import styled from 'styled-components';

import betaRibbonPng from 'img/beta-ribbon-reports.png';

import {FONT_FAMILIES} from '../../../const';

const RibbonImage = styled.img`
  position: absolute;
  width: 40px;
  left: 39px;
  top: 10px;
`;

const TopRibbon = styled.div`
  position: absolute;
  background: ${props => props.color};
  top: -6px;
  left: 15px;
  color: white;
  padding: 2px 6px;
  margin-bottom: 4px;
  margin-right: 4px;
  font-size: 9px;
  border-radius: 5px;
  width: auto;
`;

const SidebarCard = ({itemIsDisplayedInSidebar = true, label, icon, tooltip = '', selected = false, disabled = false, onClick, hasBetaRibbon = false, children}) => {
  const theme = useTheme();
  const renderRibbon = () => {
    if (!hasBetaRibbon) return null;

    if (itemIsDisplayedInSidebar) {
      return <RibbonImage alt="beta ribbon" src={betaRibbonPng} />;
    }

    return <TopRibbon color={theme.palette.warning.main}>Bêta</TopRibbon>;
  };

  return (
    <Box position="relative" overflow="visible">
      {renderRibbon()}
      <Tooltip
        slotProps={{
          tooltip: {
            sx: {
              width: 'max-content',
              maxWidth: 200
            }
          }
        }}
        PopperProps={{
          disablePortal: true
        }}
        role="tooltip"
        title={tooltip}
        placement="right-end"
      >
        <Box
          data-testid="sidebar-card-container"
          onClick={disabled ? null : onClick}
          variant="outlined"
          position="relative"
          sx={{
            pt: hasBetaRibbon ? 0.5 : 0,
            cursor: disabled ? 'not-allowed' : 'pointer',
            width: 64,
            height: 50,
            display: 'flex',
            alignItems: 'center',
            opacity: disabled ? 0.4 : 1
          }}
        >
          <Box
            onMouseEnter={e => {
              if (!disabled) {
                e.currentTarget.style.background = 'rgba(0, 0, 0, 0.04)';
              }
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = 'inherit';
            }}
            sx={{
              width: 60,
              height: 60,
              position: 'absolute',
              left: 2,
              top: -2,
              borderRadius: '50%',
              overflow: 'hidden'
            }}
          />
          <Grid container direction="column" justifyContent="space-between" alignItems="center" p={0.5} flexWrap="nowrap">
            <Box
              mb={0.2}
              sx={{
                '& svg': {
                  fontSize: 18
                }
              }}
            >
              {icon}
            </Box>
            <Typography lineHeight={1} color={selected ? 'primary' : 'text.secondary'} textAlign="center" fontFamily={FONT_FAMILIES.BODY} fontWeight="bold" fontSize={10}>
              {label}
            </Typography>
            {children}
          </Grid>
        </Box>
      </Tooltip>
    </Box>
  );
};

SidebarCard.propTypes = {
  label: string.isRequired,
  icon: node,
  tooltip: string,
  selected: bool,
  disabled: bool,
  hasBetaRibbon: bool,
  onClick: func,
  children: node,
  itemIsDisplayedInSidebar: bool
};

export default SidebarCard;
